import { useCallback } from 'react';
import { useResolve } from '../Container';
import { PopupDefinition } from './Popup';
import { PopupManager } from './PopupManager';

export const usePopup = () => {
    const popupManager = useResolve(PopupManager);

    const showPopup = useCallback((popup: PopupDefinition) => {
        return popupManager.invoke(popup);
    }, [popupManager]);

    return { showPopup };
};
